import React from 'react'
import { CollectionTable } from '..'

const Categories = props => (
  <CollectionTable selectable={false} type="category" history={props.history} />
)

export default Categories
